<template>
    <div>
        <!-- Header -->
        <b-dropdown-header class="border-bottom text-left">
            <b-row align-h="between">
                <b-col>
                    <h6 class="justify-content- between font-weight-semibold">
                        {{ $t("Notifications") }}
                        <b-badge v-if="unreadNotificationsCount() > 0" pill variant="info" class="py-1 px-2 font-weight-normal" >
                            {{ $t("UnreadCount", { count: unreadNotificationsCount()})}}
                        </b-badge>
                    </h6>
                </b-col>
                <b-col>
                    <h6 role="button" class="text-right text-info" @click="setAllAsRead" ><u>{{ $t("MarkAllAsRead") }}</u></h6>
                </b-col>
            </b-row>
        </b-dropdown-header>

        <!-- Liste des x dernières notifications -->
        <b-dropdown-item link-class="p-0">
            <b-list-group flush>
                <template v-if="NewsNotifications.length > 0">
                    <b-list-group-item v-for="notification in filteredNotifications()" :key="notification.Id" @click="openNotification(notification)" button 
                    :class="['d-flex', 'justify-content-between', 'align-items-center', 'px-3', 'py-2', notification.IsRead ? 'bg-white' : 'bg-gray-light']">
                        <b-media class="mr-3">
                            <!-- Icone Enveloppe lu/non lu -->
                            <template #aside>
                                <b-avatar :variant="notification.IsRead ? 'gray-light' : 'white'" size="md" :class="['mr-3']">
                                    <b-icon v-if="notification.IsRead" icon="envelope-open" />
                                    <b-icon v-else icon="envelope-fill" variant="info" />
                                </b-avatar>
                            </template>
                            <!-- Titre + date de publication -->
                            <div class="mr-3">
                                <span :class="['text-black', {'font-weight-semibold': !notification.IsRead}]" >{{ notification.Title }}</span>
                                <small class="text-muted d-block">
                                    {{ notification.PublishDate | formatDate('DD/MM/YYYY') }}
                                </small>
                            </div>
                        </b-media>
                    </b-list-group-item>
                </template>

                <b-list-group-item v-else class="text-center py-4">
                    <b-card-text>{{ $t('NoNotification') }}</b-card-text>
                </b-list-group-item>
            </b-list-group>
        </b-dropdown-item>

        <!-- Footer -->
        <b-dropdown-divider></b-dropdown-divider>

        <b-dropdown-item class="text-center" @click="showAllNotifications">
            <h6 class="text-info">
                <u>{{ $t('SeeAll') }}</u> 
            </h6>
        </b-dropdown-item>
    </div>
</template>

<script lang="ts">
    import { Prop, PropSync, Vue } from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import NewsNotification from '@/types/NewsNotification';
    import locales from './locales/LastNotification.json';

    @Component({
        i18n: { messages: locales }
    })
    export default class LastNotification extends Vue {
        @Prop({default : () => []})
        public NewsNotifications: NewsNotification[];

        /** Contrôle d'affichage de la modal searchNews  */
        @Prop({ default: () => 0 }) 
        public UnreadCount!: number;

        /** indication de la limite d'élements à afficher sur la liste des notifications */
        private limitDisplayNotifications : number = 5

        /** Verification si des notifications n'ont pas été lues */
        private unreadNotificationsCount(): number {
            return this.NewsNotifications.filter((notification: NewsNotification) => notification.IsRead == false).length;
        }

        /** Permet de passer en lu toutes les notifications de l'utilisateur */
        private async setAllAsRead(){
            // On marque en lue toutes les notifications de l'utilisateur
            await this.$store.dispatch('NotificationsStore/MarkAllNewsAsRead');

            // rafraîchir la liste (sera à jour côté back avec IsRead à true)
            await this.$store.dispatch('NotificationsStore/LoadNewsNotifications', { lazy : true });
        }

        /** Filtre la liste des notifications lors de l'affichage des X dernières notifications */
        private filteredNotifications() : NewsNotification[]{
            return this.NewsNotifications.slice(0, this.limitDisplayNotifications);
        }

        /** Ouvre la modal News à la sélection d'une notification et la marque comme lue si nécessaire */
        private async openNotification(notification: NewsNotification) {
            // Étape 1 : Récupération des informations de la notification à ouvrir
            await this.$store.dispatch('NotificationsStore/LoadNews', notification.Id);

            // La notifiation est en non lue
            if(!notification.IsRead) {
                // Étape 2 : marquer la notification comme lue
                await this.$store.dispatch('NotificationsStore/MarkNewsAsRead');
            
                // Étape 3 : rafraîchir la liste des notifications
                await this.$store.dispatch('NotificationsStore/LoadNewsNotifications', { lazy : true });
            }

            // Étape 4 : affiche la modale
            await this.$store.dispatch('NotificationsStore/DisplayNews');
        }

        /** Affiche la modal SearchNews (pour afficher toutes les notifications) */
        private async showAllNotifications() {
            // Affiche la modale
            await this.$store.dispatch('NotificationsStore/DisplaySearchNews')
        }
    }
</script>

<style>
</style>